import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7.021 15.55L7.014 12H5V19H12V16.986L8.45 16.979L19 6.429L17.571 5L7.021 15.55Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongBottomDown"
);
